import { useQuery } from "react-query";
import authAPI from "../authAPI";

export const useAllFeideOrganizations = (options = {}) => {
  return useQuery(
    ["allFeideOrganizations"],
    async () => {
      const result = await authAPI.getAllFeideOrganizations();
      return result;
    },
    {
      ...options,
    }
  );
};
